import { Asterisk } from "lucide-react";

export default function Marquee({ items = [], dark = false, className = "" }) {
  const Row = () => (
    <div className="flex shrink-0">
      {items.map((t, i) => (
        <span key={i} className="flex items-center gap-8 pr-8">
          <span className="font-serif italic text-lg sm:text-xl whitespace-nowrap">{t}</span>
          <Asterisk className="w-4 h-4 text-gold shrink-0" aria-hidden="true" />
        </span>
      ))}
    </div>
  );
  return (
    <div
      aria-hidden="true"
      className={`overflow-hidden border-y py-4 ${
        dark ? "border-ivory/10 text-ivory/75" : "border-burgundy/10 text-burgundy/80"
      } ${className}`}
    >
      <div className="marquee-track flex w-max">
        <Row />
        <Row />
      </div>
    </div>
  );
}
